'use client';

import { Box, factory, Flex, Grid, omitText, Typography, useWindowSize } from '@kohler-dsm-library/kohler-core';
import { ArrowLeftIcon, CloseIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './index.module.scss';

export const LoginMenu = factory((props, ref) => {
  const {
    className,
    headingSignIn,
    headingSignOut,
    loggedInCTAs,
    loggedOutCTAs,
    signOutCTA,
    isLoggedIn,
    setIsOpenMobileMenu,
    setMenuType,
    ...rest
  } = props;

  const classNames = clsx(className, 'kohler-login-menu-root', classes.loginMenu);
  const { width } = useWindowSize();
  const isSmallerScreen = width < 1024;

  // Desktop backdrop click handler
  const handleBackdropClick = (e) => {
    setMenuType?.(null)
    if (!isSmallerScreen) {
      if (setIsOpenMobileMenu) setIsOpenMobileMenu(false);
    }
  };

  return (
    <div className={classes.loginMenuBackdrop}>
    <Box id="login-menu" component="div" ref={ref} className={classNames} {...rest}>
      <Grid className={clsx('center-grid', classes.loginMenuGridGap)}>
        <Box className={classes.loginMenuMobileClose}>
          <Box
            component="button"
            type="button"
            onClick={() => {
              setMenuType?.(null);
              if (setIsOpenMobileMenu) {
                setIsOpenMobileMenu(false);
              }
            }}
            className={classes.loginMenuMobileCloseIcon}
          >
            <CloseIcon withBoundingBox={false} size="medium" />
          </Box>
          <Typography
            size="label-regular-m"
            component="button"
            type="button"
            textColor="var(--content-secondary)"
            className={classes.loginMenuMobileBackText}
            onClick={() => setMenuType?.(null)}
          >
            <ArrowLeftIcon withBoundingBox={false} size="small" /> Menu
          </Typography>
        </Box>
        <Flex className={classes.loginMenuContent}>
          {isLoggedIn && headingSignIn && (
            <Typography
            size="navigation-overlay-title"
            textColor="var(--Primary-White, #FFF);"
            className={classes.loginMenuHeading}
            >
              {headingSignIn.text}
            </Typography>
          )}
          {!isLoggedIn && headingSignOut && (
            <Typography
            size="navigation-overlay-title"
             textColor="var(--Primary-White, #FFF);"
            className={classes.loginMenuHeading}
            >
              {headingSignOut.text}
            </Typography>
          )}
        </Flex>
        {(loggedInCTAs || loggedOutCTAs) && (
          <Flex
            className={classes.loginMenuContentList}
            justifyContent="flex-start"
            alignItems="flex-start"
            wrap="nowrap"
          >
            <Box className={classes.loginMenuContentListGroup}>
              {isLoggedIn && loggedInCTAs && loggedInCTAs.slice(0, 2).map((CTA) => (
                <Typography
                  key={CTA.text}
                  component={'href' in CTA && CTA?.href ? (CTA.component ?? 'a') : (CTA.component ?? 'button')}
                  {...omitText(CTA)}
                  size={isSmallerScreen ? 'navigation-overlay-item-l' : 'h6'}
                  textColor="var(--Primary-White, #FFF)"
                  className={classes.loginMenuContentListItem}
                >
                  {CTA.text}
                </Typography>
              ))}
            </Box>
            <Flex
              className={
                !isLoggedIn
                  ? clsx(classes.loginMenuContentListRightGroup, classes.loginMenuContentListRightGroupLoggedOut)
                  : classes.loginMenuContentListRightGroup
              }
              alignItems="flex-start"
              style={
                !isLoggedIn
                  ? {
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      gap: '0',
                      marginLeft: '0',
                    }
                  : undefined
              }
            >
              {isLoggedIn && loggedInCTAs && loggedInCTAs[2] && (
                <Typography
                  component={
                    'href' in loggedInCTAs[2] && loggedInCTAs[2]?.href
                      ? loggedInCTAs[2].component ?? 'a'
                      : loggedInCTAs[2].component ?? 'button'
                  }
                  {...omitText(loggedInCTAs[2])}
                  size={isSmallerScreen ? 'navigation-overlay-item-l' : 'h6'}
                  textColor="var(--Primary-White, #FFF)"
                  className={classes.loginMenuContentListItem}
                >
                  {loggedInCTAs[2].text}
                </Typography>
              )}
              {!isLoggedIn &&
                loggedOutCTAs &&
                loggedOutCTAs.map((CTA) => {
                  return (
                    <li key={CTA.text} style={{ listStyle: 'none', margin: 0, padding: 0 }} onClick={handleBackdropClick}>
                      <Typography
                        component={
                          'href' in CTA && CTA?.href
                            ? CTA.component ?? 'a'
                            : CTA.component ?? 'button'
                        }
                        {...omitText(CTA)}
                        size={isSmallerScreen ? 'navigation-overlay-item-l' : 'h6'}
                        textColor="var(--Primary-White, #FFF) "
                      className={clsx(
                        classes.loginMenuContentListItem,
                        !isLoggedIn && classes.loginMenuContentListItemLoggedOut
                      )}
                      >
                        {CTA.text}
                      </Typography>
                    </li>
                  );
                })}
              {isLoggedIn && signOutCTA && (
                <Typography
                  component={
                    'href' in signOutCTA && signOutCTA?.href
                      ? signOutCTA.component ?? 'a'
                      : signOutCTA.component ?? 'button'
                  }
                  {...omitText(signOutCTA)}
                  size={isSmallerScreen ? 'label-regular-l' : 'label-regular-m'}
                  textColor="var(--Primary-White, #FFF)"
                  className={classes.loginMenuContentListItem}
                >
                  {signOutCTA.text || 'Sign Out'}
                </Typography>
              )}
            </Flex>
          </Flex>
                  )}
                </Grid>
              </Box>
    </div>
            );
          });